// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"43d7eec3","404":"74c73ab6","498":"b8e30115","787":"b9d38478"}[chunkId] + ".chunk.js";
};